import { Time } from '@angular/common';
import { IsBoolean, IsDate, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';

export class BusinessHolidayHoursDto extends BaseDto {

  @IsNumber()
  merchantId: number;

  @IsString()
  name: string;

  @IsDate()
  holidayDate: Date;

  @IsBoolean()
  isOpen: boolean;

  @IsDate()
  @IsOptional()
  startTime?: Time;

  @IsDate()
  @IsOptional()
  endTime?: Time;

  @IsDate()
  @IsOptional()
  createdDate?: Date;

  @IsDate()
  @IsOptional()
  modifiedDate?: Date;

  @IsNumber()
  @IsOptional()
  version?: number
}
